module.exports = __webpack_public_path__ + "static/media/bracelet.f2d974f5.png";